export function throwUnreachable(_value?: never): never {
  throw new Error(`Didn't expect to get here with value ${_value}`)
}
